import React from 'react'
import Projects from '../../components/Projects'

function Projs() {
    return (
        <>
            <Projects />
        </>
    )
}

export default Projs
